import service from "Utility/Service";
import { TimestampToDate } from "../../Utility/Fetch";
import { useQuery, useQueryClient, useMutation } from "react-query";
import axios from "axios";
import { AxiosRequestConfig } from "axios";
import { message } from "antd";
import { TabPaneKey } from "./Device/Health_Modal";
import { BrokerMessage } from "Utility/Types/alarm_event_notification";
import { GetSetDevice } from "Utility/Types/status_identity_get_set";
import { DevicesIdentity } from "Utility/Types/status_identity_get_set";

const getIdentityByCid = async (level: any, stateCid: any, loginCid: any, id?: string | undefined) => {
  let body: any = {
    get: {
      device_identity: {
        filter: {},
        nodeInf: {},
        obj: {
          identity: {},
        },
      }
    }
  };

  if (level === "super_super" && stateCid !== "") {
    body.get.device_identity.filter.cid = stateCid;
  } else if (level !== "super_super") {
    body.get.device_identity.filter.cid = loginCid;
  }
  if (id) {
    body.get.device_identity.filter.id = id;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: body,
  };

  const { data }: { data: DevicesIdentity } = await service(config);
  return data;
};

export const useIdentity = (level: string, stateCid: string, loginCid: string, id?: string | undefined) => {
  return useQuery(["identity", stateCid], () => getIdentityByCid(level, stateCid, loginCid, id), { retry: false });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// TODO:FOR GROUP FILTER 尋找正在跑 WAN ETH 、 LET
const getDeviceConfigByCid = async (model: string,cid:string) => {
  // 如果 model 是無效值，直接返回 null 或 undefined
  if (!model) return null;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      get: {
        device_cfg: {
          filter: cid === "" ? { connect: true, model: model }:
          { connect: true, model: model ,cid:cid },
          nodeInf: {},
          obj: {
            wan: {},
            lte: {
              sim: [],
            },
            identity: {},
          },
        },
      },
    },
  };

  const { data }: { data: GetSetDevice } = await service(config);
  return data;
};

export const useDeviceConfigForFilter = (model: string,cid:string) => {
  // 使用 useQuery 並確保 model 有值才啟用
  return useQuery(
    ["deviceConfig_FW_Filter"],
    () => getDeviceConfigByCid(model,cid),
    { enabled: !!model }
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getLocationByCid = async (level: any, stateCid: any, loginCid: any) => {
  let body: any = { get: { city: { filter: {} } } };

  if (level === "super_super" && stateCid !== "") {
    body.get.city.filter.cid = stateCid;
  } else if (level !== "super_super") {
    body.get.city.filter.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: body,
  };

  const { data } = await service(config);
  return data;
};

export const useDeviceLocation = (level: string, stateCid: string, loginCid: string) => {
  return useQuery(["location", stateCid], () => getLocationByCid(level, stateCid, loginCid));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getNodeByCid = async (level: any, stateCid: any, loginCid: any) => {
  let body: any = { get: { nodeInf: { filter: {}, nodeInf: { model: {} } } } };

  if (level === "super_super" && stateCid !== "") {
    body.get.nodeInf.filter.cid = stateCid;
  } else if (level !== "super_super") {
    body.get.nodeInf.filter.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: body,
  };

  const { data } = await service(config);
  return data;
};

export const useDeviceNode = (level: string, stateCid: string, loginCid: string) => {
  return useQuery(["deviceNode", stateCid], () => getNodeByCid(level, stateCid, loginCid));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getAlarmById = async (id: string | undefined) => {
  const config1: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: { get: { alarm_log: { filter: { id: id } } } },
  };
  const config2: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: { get: { current_alarm: { filter: { id: id } } } },
  };

  const { acc, per } = await axios.all([service(config1), service(config2)]).then(
    axios.spread((acc, per) => {
      return { acc, per };
    })
  );
  const alarmLog = acc.data.response.alarm_log.list[0].alarm_list.map((item: any, index: number) => {
    item.key = index;
    item.category = item.message === "Node disconnected" ? "NMS" : "Device";
    item.message = item.message === "DI (Dying Gasp)" ? "Loss of Power" : item.message; // AE asked to change
    return item;
  });

  const currentAlarm = per.data.response.current_alarm.list[0].alarm_list.map((item: any, index: number) => {
    item.key = index;
    item.category = item.message === "Node disconnected" ? "NMS" : "Device";
    return item;
  });

  return { alarmLog, currentAlarm };
};

export const useAlarmLog = (id: string | undefined, alarmTableVisible: boolean) => {
  return useQuery(["deviceAlarm", id], () => getAlarmById(id), { enabled: !!id && alarmTableVisible });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const clearAlarmByID = (id: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/cmd",
    data: { set: { clean_alarm_log: { filter: { id: id } } } },
  };

  return service(config);
};

export const useClearAlarmLog = (id: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation((id: string | undefined) => clearAlarmByID(id), {
    onSuccess: () => queryClient.invalidateQueries(["deviceAlarm", id]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getAlarmLogByCID = async (stateCid: string, level: string) => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: `/api/alarmlog/${level === "super_super" && stateCid !== "" ? `?cid=${stateCid}` : ""}`,
  };

  const { data } = await service(config);

  return data;
};

export const useAlarmLogList = (stateCid: string, level: string, isLogin: boolean) => {
  return useQuery(["deviceAlarmLogList", stateCid], () => getAlarmLogByCID(stateCid, level), {
    enabled: isLogin,
    refetchInterval: 360000,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getCurrentAlarmByCID = async (stateCid: string, level: string) => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: `/api/currentalarm/${level === "super_super" && stateCid !== "" ? `?cid=${stateCid}` : ""}`,
  };

  const { data } = await service(config);

  return data;
};

export const useCurrentAlarmList = (stateCid: string, level: string, isLogin: boolean) => {
  return useQuery(["deviceCurrentAlarmList", stateCid], () => getCurrentAlarmByCID(stateCid, level), {
    enabled: isLogin,
    refetchInterval: process.env.NODE_ENV !== "production" ? 290000 : 360000,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getDeviceConfigById = async (id: string | undefined) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      get: {
        device_cfg: {
          filter: { id: id },
          nodeInf: {},
          obj: {
            // report_period: {},
            // lan: {},
            // wan: {},
            // lte: {},
            // wifi: {},
            // system: {},
          },
        },
      },
    },
  };

  const { data }: { data: GetSetDevice } = await service(config);

  const responseData = data.response.device_cfg[0];
  // if(data.response.device_cfg[0].obj !== 'No Response!'){
  responseData.nodeInf.name_or_id =
    responseData.nodeInf.name !== "" ? responseData.nodeInf.name : responseData.nodeInf.id;
  // }else{
  //   message.error('No Response!')
  // }
  return responseData;
};

export const useDeviceConfig = (id: string | undefined) => {
  return useQuery(["deviceConfig", id], () => getDeviceConfigById(id), { enabled: !!id });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getConfigByFileName = async (level: string, stateCid: string, loginCid: string, file: string | undefined) => {
  let body: any = { download_file: { name: file, type: "json_yml" } };

  if (level === "super_super" && stateCid !== "") {
    body.download_file.cid = stateCid;
  } else {
    body.download_file.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/repository",
    data: body,
  };

  const { data } = await service(config);
  const responseData = data.response.repository.set.device_cfg;
  return responseData;
};

export const useGetConfigByFile = (level: string, stateCid: string, loginCid: string, file: string | undefined) => {
  return useQuery(["deviceConfigByFile", file], () => getConfigByFileName(level, stateCid, loginCid, file), {
    enabled: !!file,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const submitConfig = async (JSON_config: any) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: JSON_config,
  };

  const { data } = await service(config);
  const responseData = data.response?.device_cfg;

  let failureDevices: any[] = [];
  let rebootDevices: any[] = [];
  let errorDevices: any[] = [];
  let successDevices: any[] = [];

  responseData.forEach((item: any) => {
    let deviceInf = {
      id: item.nodeInf.id,
      name: item.nodeInf.name,
      name_or_id: item.nodeInf.name !== "" ? item.nodeInf.name : item.nodeInf.id,
    };
    if (item.obj === "No Response!") {
      failureDevices.push(deviceInf);
    } else if (item.obj?.["$reboot"]) {
      rebootDevices.push(deviceInf);
    } else if (item.obj?.["$errors"]?.length) {
      errorDevices.push({
        ...deviceInf,
        message: item.obj["$errors"],
      });
    } else {
      successDevices.push(deviceInf);
    }
  });

  // return service(config);
  return { failureDevices, rebootDevices, errorDevices, successDevices, total: responseData?.length };
};

export const useSubmitConfig = () => {
  // const queryClient = useQueryClient();
  return useMutation(
    (JSON_config: any) => submitConfig(JSON_config)
    // {
    //   onSuccess: () => queryClient.invalidateQueries(["deviceAlarm", id]),
    // }
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const saveConfigByName = (props: any) => {
  const { level, stateCid, loginCid, JSONConfig, formData } = props;

  let body = {
    upload_file: {
      name: `${formData.yml_filename}.yml`,
      type: "json_yml",
      inf: { model: formData.model },
      json: JSONConfig,
      cid: {},
    },
  };

  if (level === "super_super" && stateCid !== "") {
    body.upload_file.cid = stateCid;
  } else {
    body.upload_file.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/repository",
    data: body,
  };

  return service(config);
};

export const useSaveConfig = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => saveConfigByName(props), {
    onSuccess: () => queryClient.invalidateQueries(["repositoryList"]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const rebootByID = async (deviceID: string[]) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      reboot: { device_cfg: { filter: { id: deviceID }, nodeInf: {} } },
    },
  };

  const { data } = await service(config);
  let rebootfailDevices: any[] = [];
  let rebootSuccessDevices: any[] = [];
  const responseData = data.response?.device_cfg;

  if (responseData) {
    responseData.forEach((item: any) => {
      if (item.obj === "No Response!") {
        rebootfailDevices.push({
          id: item.nodeInf.id,
          name: item.nodeInf.name,
        });
      } else {
        rebootSuccessDevices.push({
          id: item.nodeInf.id,
          name: item.nodeInf.name,
        });
      }
    });
  }

  return { rebootfailDevices, rebootSuccessDevices, total: responseData?.length };
};

export const useDeviceReboot = () => {
  // const queryClient = useQueryClient();
  return useMutation(
    (deviceID: string[]) => rebootByID(deviceID)
    // {
    //   onSuccess: () => queryClient.invalidateQueries(["deviceAlarm", id]),
    // }
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deleteNodeByID = (props: any) => {
  const { level, stateCid, loginCid, deleteList } = props;

  let body: any = { delete_device: { device_list: deleteList } };

  if (level === "super_super" && stateCid !== "") {
    body.delete_device.cid = stateCid;
  } else {
    body.delete_device.cid = loginCid;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/device_mgnt/device",
    data: body,
  };

  return service(config);
};

export const useDeleteNode = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deleteNodeByID(props), {
    onSuccess: () => queryClient.invalidateQueries(["status", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// FIXME:
const editCoordinate = (props: any) => {
  const { id, lati_longi } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      set: {
        lati_longi: {
          list: [
            {
              id: id,
              lati_longi:
                lati_longi === null || lati_longi === undefined || lati_longi === ""
                  ? [0, 0]
                  : JSON.parse(`[${lati_longi}]`),
            },
          ],
        },
      },
    },
  };

  return service(config);
};

export const useEditCoordinate = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => editCoordinate(props), {
    onSuccess: () => queryClient.invalidateQueries(["status", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// FIXME:
const getCoordinate = async (props: any) => {
  const ids = props;
  if (!ids) return;

  const idsObj: any = [];
  ids.map((item: any) => {
    idsObj.push({ id: `${item}` });
  });

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      get: {
        lati_longi: {
          list: idsObj,
        },
      },
    },
  };

  const { data } = await service(config);
  return data.response;
};

export const useGetCoordinate = (props?: any | undefined) => {
  return useQuery("get-coordinate", () => getCoordinate(props), {});
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const deviceRename = (props: any) => {
  const { cid, id, name } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      set: {
        node_name: {
          filter: { cid: cid },
          list: [{ id: id, name: name }],
        },
      },
    },
  };

  return service(config);
};

export const useDviceRename = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deviceRename(props), {
    onSuccess: () => queryClient.invalidateQueries(["status", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const updateLocations = (props: any) => {
  const { value } = props;

  const location_ID_list = value.devices.map((item: string) => {
    return { id: item, city: value.city_name || "" };
  });

  let body = { set: { city: { filter: {}, list: location_ID_list } } };

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: body,
  };

  return service(config);
};

export const useUpdateLocations = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => updateLocations(props), {
    onSuccess: () => queryClient.invalidateQueries(["status", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getGPSbyID = async (id: string | undefined) => {
  let yesterday: number = Math.round(Date.now() / 1000 - 12 * 60 * 60);
  let today: number = Math.round(Date.now() / 1000);

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: {
      get: {
        gps_track: {
          filter: { id: id },
          utc_range: { start: yesterday, end: today },
          nodeInf: {},
          obj: {},
        },
      },
    },
  };

  const { data } = await service(config);
  const nodeInf = data.response.gps_track[0].nodeInf;
  let coordinateArr: [any, number, number, number][] = data.response?.gps_track?.[0]?.gps.list || [];
  let centerPosition: [number, number] = [0, 0];
  let lastPoint;
  let polylineData: number[][] | [] = [];
  let coordinate: any = [[`N/A (no GPS data)`, 0, 0, 0]];
  if (coordinateArr?.length) {
    coordinateArr.forEach((item: [any, number, number, number]) => {
      let date = new Date(item[0] * 1000);
      item[0] = `${date}`;
    });
    lastPoint = coordinateArr[coordinateArr.length - 1];
    centerPosition = [lastPoint[1], lastPoint[2]];
    coordinate = [lastPoint];
    polylineData = coordinateArr.map((item) => [item[1], item[2]]);
  }

  return { nodeInf, coordinateArr, centerPosition, coordinate, polylineData, lastPoint };
};

export const useDeviceGPS = (id: string | undefined, mapVisible: boolean) => {
  return useQuery(["deviceGPS", id], () => getGPSbyID(id), { enabled: !!id && mapVisible });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getGPSbyDate = async (props: any) => {
  const { values, id, time_zone } = props;

  let from_time: any = values?.RangePicker[0]._d;
  from_time = Math.round(new Date(from_time.getFullYear(), from_time.getMonth(), from_time.getDate()).getTime() / 1000);
  let To_time = values?.RangePicker[1]._d;
  To_time =
    Math.round(new Date(To_time.getFullYear(), To_time.getMonth(), To_time.getDate()).getTime() / 1000) + 24 * 60 * 60;

  const config: AxiosRequestConfig = {
    method: "post",
    headers: { "Content-Type": "application/json" },
    url: "/cmd",
    data: {
      get: {
        gps_track: {
          filter: { id: id },
          utc_range: { start: from_time, end: To_time },
          nodeInf: {},
          obj: {},
        },
      },
    },
  };

  const { data } = await service(config);

  let coordinateArr: [any, number, number, number][] = data.response?.gps_track?.[0]?.gps.list || [];
  let trackerTableData: any = [];
  let polylineData: [number, number][] = [];
  let drawerVisible: boolean = false;
  let coordinate: any;
  let centerPosition: [number, number] | undefined;
  if (coordinateArr?.length) {
    //要呈現的Table Data
    trackerTableData = coordinateArr
      .map((item) => {
        return {
          readableTime: TimestampToDate(item[0] * 1000, time_zone, true),
          lat: item[1],
          log: item[2],
          alt: item[3],
        };
      })
      .reverse();

    coordinateArr.forEach((item) => {
      let date = new Date(item[0] * 1000);
      item[0] = `${date}`;
    });

    const lastPoint = coordinateArr[coordinateArr.length - 1];

    coordinate = [lastPoint];
    centerPosition = [lastPoint[1], lastPoint[2]];
    polylineData = coordinateArr.map((item) => [item[1], item[2]]); //track list的歷史座標
    drawerVisible = true;
  } else {
    message.error("No Data");
  }

  return { trackerTableData, polylineData, drawerVisible, coordinate, centerPosition };
};

export const useGetGPSbyDate = () => {
  // const queryClient = useQueryClient();
  return useMutation(
    (props: any) => getGPSbyDate(props)
    // {
    //   onSuccess: () => queryClient.invalidateQueries(["status", stateCid]),
    // }
  );
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const subscribeBroker = (props: any) => {
  const { deviceID, cid } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/api/diagnose",
    data: { id: deviceID, cid: cid },
  };

  return service(config);
};

export const useSubscribeBroker = () => {
  return useMutation((props: any) => subscribeBroker(props));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const getBrokerMessageByDeviceID = async (id: string) => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: `/api/diagnosemessage/${id}/`,
  };

  const { data }: { data: BrokerMessage } = await service(config);

  return data;
};

export const useBrokerMessage = (id: string, currentTab: TabPaneKey) => {
  return useQuery(["brokerMessage"], () => getBrokerMessageByDeviceID(id), {
    enabled: currentTab === "diagnosis",
    refetchInterval: 10000,
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const pingBroker = async () => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: `/api/pingbroker`,
  };

  const { data } = await service(config);

  return data;
};

export const usePingBroker = () => {
  return useMutation(() => pingBroker());
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const eventLog = async (props: any) => {
  const { cid, message } = props;
  const currentTime = Date.now();
  const timestamp = Math.round(currentTime / 1000);
  const config: AxiosRequestConfig = {
    method: "post",
    url: `/api/eventlog/`,
    data: { cid: cid, message: message, timestamp: timestamp },
  };

  const { data } = await service(config);

  return data;
};

export const useUpdateEventLog = () => {
  return useMutation((props: any) => eventLog(props));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const UploadSysLog = (param: any) => {
  const { level, stateCid, loginCid, time_zone, export_all_log, deviceRecord } = param;

  const data: any = {
    set: {
      log_export: [
        { id: deviceRecord.id, inf: { model: deviceRecord.model }, type: "log", export_all_log: export_all_log },
      ],
    },
  };

  if (level === "super_super" && stateCid !== "") {
    data.set.log_export[0].cid = stateCid;
  } else if (level !== "super_super") {
    data.set.log_export[0].cid = loginCid;
  }

  //judge file nme

  let date = TimestampToDate(Date.now(), time_zone);
  data.set.log_export[0].name = `${deviceRecord.name_or_id}_${export_all_log ? "All" : "Sys"}_Log_${date.replace(
    ":",
    "_"
  )}.tgz`;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: data,
  };

  return service(config);
};

export const useUploadSysLog = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((param: any) => UploadSysLog(param), {
    onSuccess: () => queryClient.invalidateQueries(["repositoryList", stateCid]),
  });
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const get_DO_by_ID = async (deviceID: string) => {
  const config: AxiosRequestConfig = {
    data: {
      get: {
        device_cfg: {
          filter: { id: deviceID },
          nodeInf: {},
          obj: { system: { DO: {} } },
        },
      },
    },
    method: "post",
    url: "/cmd",
  };

  const { data } = await service(config);

  return data;
};

export const useDO = (id: string) => {
  return useQuery(["digitalOutput"], () => get_DO_by_ID(id));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const updateDO = async (props: any) => {
  const { deviceID, mode, time } = props;
  const config: AxiosRequestConfig = {
    data: {
      set: {
        device_cfg: {
          filter: { id: deviceID },
          obj: { system: { DO: { mode: mode, time: time } } },
        },
      },
    },
    method: "post",
    url: `/cmd`,
  };

  const { data } = await service(config);

  return data;
};

export const useUpdateDO = () => {
  return useMutation((param: any) => updateDO(param));
};

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const updateDescriptions = (props: any) => {
  const { value } = props;

  const description_ID_list = value.devices.map((item: string) => {
    return { id: item, description: value.description_name || "" };
  });

  let body = { set: { description: { filter: {}, list: description_ID_list } } };

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/cmd",
    data: body,
  };

  return service(config);
};

export const useUpdateDescriptions = (stateCid: string) => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => updateDescriptions(props), {
    onSuccess: () => queryClient.invalidateQueries(["status", stateCid]),
  });
};